import React, { useEffect, useState, useRef } from "react";
import "./main.css";
import ps from "./dp.png";
import ic from "./github.png";
import $ from "jquery";
import { AiOutlineDoubleLeft } from "react-icons/ai";
import { BiLinkExternal } from "react-icons/bi";
import { TfiImage } from "react-icons/tfi";
import { IoCaretBack } from "react-icons/io5";
import Data, { details, symbols } from "./dataStore";
import Mob from "./mob";

let i = 1;
let d,
  s = 0.4,
  count = 0,
  a = 0,
  b = 0,
  c = 0;
function Main() {
  const jQueryCode = () => {
    let o = 50;
    // Scrolling animation starts here
    $(".bgm").on("wheel", function (event) {
      if (count < 26) {
        count++;
        // console.log(count);
        d = i;
        if (count === 1) {
          $("#bg2").css("background", "rgba(0,0,0,0)");
          $("#bg21").css({ justifyContent: "flex-end" });
          $("#bg21").html(
            "<h1 id='head1' style='font-size:5em;color:white;'>Let's</h1>"
          );
          $("#bg22").html(
            "<h1 id='head2' style='font-size:5em;color:white;'>go</h1>"
          );
          $("#head1").css({
            filter: "drop-shadow(0 0 0.5vmax white)",
          });
          $("#head2").css({
            filter: "drop-shadow(0 0 0.5vmax white)",
          });
          $("#bg21").css({
            backgroundColor: "black",
          });
          $("#bg22").css({
            backgroundColor: "black",
          });
        }
        $("#bg21").css({
          left: `${-d}vw`,
          letterSpacing: `${count * 0.3}vw`,
          transition: "all 0.1s",
        });
        $("#bg22").css({
          left: `${o + d}vw`,
          letterSpacing: `${count * 0.3}vw`,
          transition: "all 0.1s",
        });
        // $("#bg1").css("transform", `scale(${s})`);
        i = i + 1;
        if (s < 1) {
          s = s + 0.025;
        }
        if (count == 15) {
          $("#bg2").css({ display: "none" });
        }
      }
    });
  };

  const [skill, setSkill] = useState([]);
  const [skillCount, setSkillCount] = useState(1);
  const [flag, setFlag] = useState(0);
  const [imageData, setImageData] = useState(0);
  const title = useRef();
  const content = useRef();
  const image = useRef();
  const [scrollAmt, setScrollAmt] = useState(0);
  const [scrollAmtContent, setScrollAmtContent] = useState(0);
  const [imageScroll, setImageScroll] = useState(0);
  function gotoProjects() {
    $("#edu").css({ transform: "scale(5)" });
    // console.log("Clicked");
    setTimeout(() => {
      setFlag(1);
      // $("#projMain").css({ animation: "tileAnim 2s ease forwards" });
    }, 700);
  }
  function backToSkills() {
    setSkillCount(0);
    setSkill(symbols.fe);
    setScrollAmt(0);
    setScrollAmtContent(0);
    $("#projMain").css({ transform: "scale(2.3)" });
    setTimeout(() => {
      setFlag(0);
    }, 700);
  }
  function backToProject() {
    setScrollAmt(0);
    setScrollAmtContent(0);
    setImageScroll(0);
    $("#imagesMain").css({ transform: "scale(2.3)" });
    setTimeout(() => {
      setFlag(1);
    }, 700);
  }
  let points = [];
  useEffect(() => {
    jQueryCode();
    setSkill(symbols.fe);
  }, []);

  let skills = {
    core: ["DSA", "C", "Java"],
    fe: [
      "React.js",
      "Angular",
      "Redux",
      "Html/CSS",
      "JavaScript",
      "TypeScript",
      "SCSS",
    ],
    be: ["Node.js", "MongoDB", "Express.js", "SpringBoot", "SQL"],
    vc: ["Git"],
  };

  function downScroll() {
    title.current.style.transform = `translateY(${scrollAmt - 50}vh)`;
    content.current.style.transform = `translateY(${scrollAmtContent + 50}vh)`;
    setScrollAmt(scrollAmt - 50);
    setScrollAmtContent(scrollAmtContent + 50);
  }
  function upScroll() {
    title.current.style.transform = `translateY(${scrollAmt + 50}vh)`;
    content.current.style.transform = `translateY(${scrollAmtContent - 50}vh)`;
    setScrollAmt(scrollAmt + 50);
    setScrollAmtContent(scrollAmtContent - 50);
  }

  function imagesSwitch(id) {
    setImageData(id);
    setFlag(2);
  }
  const imageSwitchLeft = () => {
    image.current.style.transform = `translateX(${imageScroll + 70}vw)`;
    setImageScroll(imageScroll + 70);
  };
  const imageSwitchRight = () => {
    image.current.style.transform = `translateX(${imageScroll - 70}vw)`;
    setImageScroll(imageScroll - 70);
  };
  const skillChange = (num) => {
    if (num == 1) {
      if (skill[0][1] != "React.js") {
        $(".skillsContainer").css({
          animation: "rotateSkill 0.5s linear forwards",
        });
        let timer = setTimeout(() => {
          setSkill(symbols.fe);
          $(".skillsContainer").css({
            animation: "none",
          });
          $(`#skillField:nth-child(${skillCount})`).css({
            fontSize: "2.5vmax",
            filter: "drop-shadow(0 0 0px white)",
          });
          $(`#skillField:nth-child(1)`).css({
            fontSize: "3vmax",
            filter: "drop-shadow(0 0 10px white)",
          });
          setSkillCount(1);
          clearTimeout(timer);
        }, 500);
      }
    } else if (num == 2) {
      if (skill[0][1] != "Node.js") {
        $(".skillsContainer").css({
          animation: "rotateSkill 0.5s linear forwards",
        });
        let timer = setTimeout(() => {
          setSkill(symbols.be);
          $(".skillsContainer").css({
            animation: "none",
          });
          $(`#skillField:nth-child(${skillCount})`).css({
            fontSize: "2.5vmax",
            filter: "drop-shadow(0 0 0px white)",
          });
          $(`#skillField:nth-child(3)`).css({
            fontSize: "3vmax",
            filter: "drop-shadow(0 0 10px white)",
          });
          setSkillCount(3);
          clearTimeout(timer);
        }, 500);
      }
    } else if (num == 3) {
      if (skill[0][1] != "") {
        $(".skillsContainer").css({
          animation: "rotateSkill 0.5s linear forwards",
        });
        let timer = setTimeout(() => {
          setSkill(symbols.core);
          $(".skillsContainer").css({
            animation: "none",
          });
          $(`#skillField:nth-child(${skillCount})`).css({
            fontSize: "2.5vmax",
            filter: "drop-shadow(0 0 0px white)",
          });
          $(`#skillField:nth-child(5)`).css({
            fontSize: "3vmax",
            filter: "drop-shadow(0 0 10px white)",
          });
          setSkillCount(5);
          clearTimeout(timer);
        }, 500);
      }
    } else if (skill[0][1] != "Git") {
      $(".skillsContainer").css({
        animation: "rotateSkill 0.5s linear forwards",
      });
      let timer = setTimeout(() => {
        setSkill(symbols.vc);
        $(".skillsContainer").css({
          animation: "none",
        });
        $(`#skillField:nth-child(${skillCount})`).css({
          fontSize: "2.5vmax",
          filter: "drop-shadow(0 0 0px white)",
        });
        $(`#skillField:nth-child(7)`).css({
          fontSize: "3vmax",
          filter: "drop-shadow(0 0 10px white)",
        });
        setSkillCount(7);
        clearTimeout(timer);
      }, 500);
    }
  };
  return (
    <>
      <div className="mob">
        <Mob />
      </div>
      <div className="bgm">
        <a
          id="icon"
          target="_blank"
          href="https://github.com/Pradyumnasavadatti"
        >
          <img src={ic} id="icImg" draggable={false} />
        </a>
        <div id="bg1">
          <div id="bg12">
            {/* <div id="bg121"></div>
          <div id="bg122"></div> */}
            {flag == 0 && (
              <div id="edu">
                <div id="demo1"></div>
                <div id="demo2"></div>
                <div id="demo3"></div>
                <div id="demo4"></div>
                <div id="demo5"></div>
                <div id="demo6"></div>
                <div id="demo7"></div>
                <div id="demo8"></div>
                <div id="demo9"></div>
                <div id="demo10"></div>
                <div id="dem1"></div>
                <div id="dem2"></div>
                <div id="dem3"></div>
                <div id="dem4"></div>
                <div id="dem5"></div>
                <div id="dem6"></div>
                <div id="dem7"></div>
                <div id="dem8"></div>
                <div id="dem9"></div>
                <div id="dem10"></div>
                <div id="deo1"></div>
                <div id="deo2"></div>
                <div id="deo3"></div>
                <div id="deo4"></div>
                <div id="deo5"></div>
                <div id="deo6"></div>
                <div id="deo7"></div>
                <div id="deo8"></div>
                <div id="deo9"></div>
                <div id="deo10"></div>
                <div id="skillHead">
                  Skill<span id="shakingS">s</span>
                </div>
                <div id="projectBtn" onClick={gotoProjects}>
                  Projects
                </div>
                <div id="skills">
                  <div id="skillsLeft">
                    {skill.map((i) => {
                      return (
                        <div className="skillsContainer">
                          {i[0]}
                          {i[1]}
                        </div>
                      );
                    })}
                  </div>
                  <div id="skillsCenter">
                    <div id="skillsCenterSub"></div>
                  </div>
                  <div id="skillsRight">
                    <div
                      id="skillField"
                      onClick={() => {
                        skillChange(1);
                      }}
                    >
                      FrontEnd
                    </div>
                    <div id="skillFieldLine"></div>
                    <div
                      id="skillField"
                      onClick={() => {
                        skillChange(2);
                      }}
                    >
                      BackEnd
                    </div>
                    <div id="skillFieldLine"></div>
                    <div
                      id="skillField"
                      onClick={() => {
                        skillChange(3);
                      }}
                    >
                      Core
                    </div>
                    <div id="skillFieldLine"></div>
                    <div
                      id="skillField"
                      onClick={() => {
                        skillChange(4);
                      }}
                    >
                      Version Control
                    </div>
                  </div>
                </div>
              </div>
            )}
            {flag == 1 && (
              <div id="projs">
                <div id="projBack" onClick={backToSkills}>
                  <IoCaretBack id="projBackIcon" />
                  Back
                </div>
                <div id="projUp">
                  <div id="projUpMain">
                    {scrollAmt != 0 && (
                      <AiOutlineDoubleLeft
                        onClick={upScroll}
                        style={{
                          width: "100%",
                          height: "100%",
                          cursor: "pointer",
                        }}
                      />
                    )}
                  </div>
                </div>
                <div id="projMain">
                  <div id="projTitle">
                    <div id="projTitleSub" ref={title}>
                      {Data.map((val) => {
                        return <div id="titleContent">{val[0]}</div>;
                      })}
                    </div>
                  </div>
                  <div id="projContent">
                    <div id="projContentSub" ref={content}>
                      {details.map((val, index) => {
                        return (
                          <div id="contentContent">
                            <div id="contentContentMain">
                              <div id="ccMain">{val.description}</div>
                              <div id="ccTechs">
                                {val.tech.map((tech) => {
                                  return <div id="ccTechsSub">{tech}</div>;
                                })}
                              </div>
                              <div id="ccDeploy">
                                <div id="ccMode">
                                  {val.online && (
                                    <div id="ccModeMain" className="ccOn">
                                      <div id="ccDot"></div>Online
                                    </div>
                                  )}
                                  {!val.online && (
                                    <div id="ccModeMain" className="ccOff">
                                      <div id="ccDot"></div>Offline
                                    </div>
                                  )}
                                </div>
                                {val.online && (
                                  <div id="ccLink">
                                    <div id="ccBtn">
                                      <a
                                        href={val.link}
                                        target="_blank"
                                        style={{
                                          color: "white",
                                          textDecoration: "none",
                                        }}
                                      >
                                        <BiLinkExternal id="linkIcon" />
                                      </a>
                                    </div>
                                  </div>
                                )}
                                {!val.online && (
                                  <div id="ccImages">
                                    <div
                                      id="ccBtn"
                                      onClick={() => {
                                        imagesSwitch(Data.length - index - 1);
                                      }}
                                    >
                                      <TfiImage id="linkIcon" />
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
                <div id="projDown">
                  <div id="projDownMain">
                    {(Data.length - 1) * -50 != scrollAmt && (
                      <AiOutlineDoubleLeft
                        onClick={downScroll}
                        style={{
                          width: "100%",
                          height: "100%",
                          cursor: "pointer",
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            )}
            {flag == 2 && (
              <div id="imagesMain">
                <div
                  id="projBack"
                  style={{ color: "white" }}
                  onClick={backToProject}
                >
                  <IoCaretBack id="projBackIcon" />
                  Back
                </div>
                <div id="imagesArrow">
                  {imageScroll != 0 && (
                    <AiOutlineDoubleLeft
                      onClick={imageSwitchLeft}
                      style={{
                        color: "white",
                        width: "50%",
                        height: "10%",
                        cursor: "pointer",
                      }}
                    />
                  )}
                </div>
                <div id="imagesContainer">
                  <div id="imagesContainerSub" ref={image}>
                    {Data[imageData][1].map((val, ind) => {
                      return (
                        <img
                          id="imagesContainerTile"
                          src={val}
                          draggable={false}
                        />
                      );
                    })}
                  </div>
                </div>
                <div id="imagesArrow">
                  {imageScroll != (Data[imageData][1].length - 1) * -70 && (
                    <AiOutlineDoubleLeft
                      onClick={imageSwitchRight}
                      style={{
                        color: "white",
                        width: "50%",
                        height: "10%",
                        cursor: "pointer",
                        transform: "rotate(180deg)",
                      }}
                    />
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
        <div id="bg2">
          <div id="bg21">
            <div id="imgdiv">
              <div id="wellcome">
                <span id="letterW">W</span>
                <span id="letterE">e</span>
                <span id="letterL">l</span>
                <span id="letterL2">l</span>
                <span id="letterC">C</span>
                <span id="letterO">o</span>
                <span id="letterM">m</span>
                <span id="letterE2">e</span>
                <span>!</span>
              </div>
              <img id="img" src={ps} draggable="false" />
            </div>
          </div>
          <div id="bg22">
            <div id="bg222">
              <div id="mastery">
                <span id="letterOther">m</span>
                <span id="letterR">eR</span>
                <span id="letterOther">n</span>
              </div>
            </div>
            <div id="mtxt">
              <h1 id="mName">Pradyumna Savadatti</h1>
              <h4 id="mLink">pradyumnasavadatti7@gmail.com / @pradyumna_ps</h4>
              <p id="mPara">
                Hey there! Welcome to my website. Here you can get brief details
                about me, like my technical skills and project details.
              </p>
              <h3 id="mScroll">Scroll to get started!</h3>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Main;
